import { fromEvent as observableFromEvent, Observable, ReplaySubject } from 'rxjs';

import { map } from 'rxjs/operators';
import get from 'lodash-es/get';
import { Injectable } from '@angular/core';

export interface WindowSize {
  width: number;
  height: number;
}

export interface WindowScroll {
  x: number;
  y: number;
}

interface RedirectOptions {
  newTab?: boolean;
}

@Injectable()
export class WindowService {
  scrollStream: Observable<WindowScroll>;
  windowSize: WindowSize;
  appInstallChoiceStream: ReplaySubject<any>;

  constructor() {
    this.windowSize = { width: window.innerWidth, height: window.innerHeight };
    const windowScrollStream = observableFromEvent<Event>(window, 'scroll');
    this.appInstallChoiceStream = new ReplaySubject();
    const installPromptStream = observableFromEvent<Event>(window, 'beforeinstallprompt');

    this.scrollStream = windowScrollStream.pipe(
      map(
        (event): WindowScroll => {
          return { x: window.pageXOffset, y: window.pageYOffset };
        },
      ),
    );

    installPromptStream.subscribe((event: any) => {
      event.userChoice.then(choice => {
        this.appInstallChoiceStream.next(choice);
      });
    });
  }

  getWindowSize() {
    return this.windowSize;
  }

  isAndroid(): boolean {
    return /Android/.test(this.getUserAgent());
  }

  isIos(): boolean {
    const userAgent = this.getUserAgent();
    return /iPad/.test(userAgent) || /iPhone/.test(userAgent);
  }

  isWebKitView(): boolean {
    const isWebKit = (window as any).webkit && (window as any).webkit.messageHandlers;
    return this.isIos() && isWebKit;
  }

  postMessageToWebView(message) {
    if (get(window, ['webkit', 'messageHandlers', 'callbackHandler', 'postMessage'])) {
      (<any>window).webkit.messageHandlers.callbackHandler.postMessage(message);
    }
  }

  invokeOnInterface(iFace: string, method: string) {
    if (get(window, [iFace, method])) {
      window[iFace][method]();
    }
  }

  redirect(location: string, options: RedirectOptions = {}) {
    const { newTab } = options;
    if (newTab) {
      window.open(location, '_blank');
    } else {
      window.location.href = location;
    }
  }

  scrollToTop() {
    window.scrollTo(0, 0);
  }

  private getUserAgent(): string {
    return navigator.userAgent;
  }
}
